<template>
    <div class="navbar">
        <router-link to="/" tag='a' class="navbar__brand logo"><img src="/static/images/logo.png" alt="Bimbi" /></router-link>
        <nav class="navbar__navigation navigation">
            <ul class="navigation__list">
                <li class="navigation__item navigation__item--first">
                    <router-link to="/" class="navigation__link navigation__link--hover">Начало</router-link>
                </li>
                <li class="navigation__item">
                    <router-link to="/products" class="navigation__link navigation__link--hover2">Продукти</router-link>
                    <ul>
                        <li v-for="product in products" :key="product.id" @click="changeRoute(product.slug, product.id)">
                            <router-link  :to="'/product/'+product.slug+'/'+product.id" v-text="product.title"></router-link>
                        </li>
                    </ul>
                </li>
                <li class="navigation__item">
                    <router-link to="/contacts" class="navigation__link navigation__link--hover3">Контакти</router-link>
                </li>
                <li class="navigation__item">
                    <a :href="facebook" target="_blank" class="navigation__link navigation__link--social">
                        <img src="/static/images/social-facebook-icon.png" alt="Facebook" />
                    </a>
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>
import Product from '@/services/product'

export default {
    name: 'Navbar',
    props: ['facebook'],
    data () {
        return {
            products: null
        }
    },
    created: function () {
        Product.getAll(`${this.$root.$data.baseUrl}/products`)
            .then(res => {
                if (res.success) {
                    this.products = res.data
                }
            })
            .catch(err => console.log(err))
    },
    methods: {
        changeRoute (slug, id) {
            this.$router.push({name: 'InsideProduct', params: { slug: slug, id: id }})
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/shared/Navbar.vue?d3a72fca